// Shared utility functions for invoice layouts

export const fmtInr = (n) => `Rs ${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const numberToWords = (num) => {
  if (num === 0) return "Zero";
  
  const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  
  const convertGroup = (n) => {
    if (n === 0) return "";
    if (n < 20) return ones[n];
    if (n < 100) {
      const t = Math.floor(n / 10);
      const o = n % 10;
      return tens[t] + (o ? " " + ones[o] : "");
    }
    const h = Math.floor(n / 100);
    const r = n % 100;
    return ones[h] + " Hundred" + (r ? " and " + convertGroup(r) : "");
  };
  
  const convertIndian = (n) => {
    if (n === 0) return "";
    
    const crore = Math.floor(n / 10000000);
    const lakh = Math.floor((n % 10000000) / 100000);
    const thousand = Math.floor((n % 100000) / 1000);
    const hundred = Math.floor((n % 1000) / 100);
    const remainder = n % 100;
    
    let result = "";
    if (crore) result += convertGroup(crore) + " Crore ";
    if (lakh) result += convertGroup(lakh) + " Lakh ";
    if (thousand) result += convertGroup(thousand) + " Thousand ";
    if (hundred) result += convertGroup(hundred) + " Hundred ";
    if (remainder) result += (result ? "and " : "") + convertGroup(remainder);
    
    return result.trim();
  };
  
  const integerPart = Math.floor(num);
  const decimalPart = Math.round((num - integerPart) * 100);
  
  let words = convertIndian(integerPart);
  if (decimalPart > 0) {
    words += " and " + convertGroup(decimalPart) + " Paise";
  }
  
  return words + " Only";
};

// Helper function to calculate pagination for multi-page invoices
export const calculatePagination = (items, itemsPerPage = 15) => {
  const pages = [];
  for (let i = 0; i < items.length; i += itemsPerPage) {
    pages.push(items.slice(i, i + itemsPerPage));
  }
  return pages;
};

// Helper function to calculate GST summary pagination
export const calculateGstPagination = (items, itemsPerPage = 20) => {
  const pages = [];
  for (let i = 0; i < items.length; i += itemsPerPage) {
    pages.push(items.slice(i, i + itemsPerPage));
  }
  return pages;
};

// Helper function to get padding value
export const getPadding = (padding) => {
  const paddingMap = { none: "0", small: "8px", medium: "16px", large: "24px" };
  return paddingMap[padding] || "16px";
};

// Helper function to get background color
export const getBackground = (hasBackground) => {
  return hasBackground ? "#f0f0f0" : "transparent";
};
